import HomePage from 'pages/HomePage/HomePage'
import React from 'react'

const Stream = () => {
  return (
    <HomePage/>
  )
}

export default Stream